/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ReactPlayer from 'react-player';
// import { Line } from "rc-progress";
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class TopLiveBanner extends Component {
  state = {
    playing: false,
    playIndex: 0,
    currentPlayIndex: 0,
    mute: true,
    playUrl: '',
    imgShow: false,
    logoPlay: false,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getBanner();
    this._getWindowSize();
    window.addEventListener('resize', this._getWindowSize);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('resize', this._getWindowSize);
  };
  _getBanner = async () => {
    const result = await this._getBannerApi();

    const intReturn = result.data[0].intReturn;
    const liveData = result.data[0].listData;

    if (intReturn === 0) {
      let videoList = [];

      if (
        liveData[0].opening !== null &&
        liveData[0].opening !== null &&
        liveData[0].opening !== undefined
      ) {
        videoList.push({
          url: 'https://jjmp4.ofscdn.com' + liveData[0].opening,
        });
      }
      if (
        liveData[0].ending !== null &&
        liveData[0].ending !== null &&
        liveData[0].ending !== undefined
      ) {
        videoList.push({
          url: 'https://jjmp4.ofscdn.com' + liveData[0].ending,
        });
      }
      if (
        liveData[0].pvUrl !== null &&
        liveData[0].pvUrl !== null &&
        liveData[0].pvUrl !== undefined
      ) {
        videoList.push({
          url: 'https://jjmp4.ofscdn.com/PV/' + liveData[0].pvUrl,
        });
      }
      //console.log(videoList)
      if (this._isMounted) {
        this.setState({
          liveData,
          videoList,
        });

        this._onPlayVideo();
      }
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/topBannerLive')
      .then((response) => response)
      .catch((error) => {
        //console.log('라이브 정보를 로드중 오류가 발생했습니다.')
      });
  };
  _onPlayVideo = () => {
    const { videoList, playIndex, logoPlay } = this.state;
    let currentPlayIndex;
    //console.log(videoList)

    const playLenght = videoList.length;

    ////console.log(playIndex, playLenght)
    ////console.log('start')
    if (playLenght <= 0) {
      this.setState({
        playing: false,
        imgShow: true,
      });
    } else {
      if (playIndex >= playLenght) {
        //썸네일??? 고정!!!
        //currentPlayIndex = 0
        this.setState({
          playing: false,
          imgShow: true,
          //playUrl: videoList[currentPlayIndex].url,
          //playIndex: currentPlayIndex + 1,
          //currentPlayIndex: currentPlayIndex
        });
      } else {
        currentPlayIndex = playIndex;

        this.setState({
          playing: true,
          playUrl: logoPlay
            ? videoList[currentPlayIndex].url
            : 'https://jjmp4.ofscdn.com/TveeMovie/aniplus/logoANI.mp4',
          playIndex: currentPlayIndex + 1,
          currentPlayIndex: currentPlayIndex,
        });
      }
    }
  };
  _onReady = () => {
    this.setState({
      playing: true,
    });
  };
  _onEnded = () => {
    const { logoPlay } = this.state;
    if (!logoPlay) {
      this.setState({
        logoPlay: true,
      });
    }
    ////console.log('end')
    //애니플러스 로그 재생 후
    this._onPlayVideo();
  };
  _goItem = (contentSerial) => {
    const { history } = this.props;
    history.push('/items/' + contentSerial);
  };
  _getWindowSize = () => {
    //console.log(window.innerWidth)
    const hSize = (window.innerWidth - 18) * (1080 / 1920);
    this.setState({
      wSize: window.innerWidth - 18,
      hSize: hSize,
    });
  };
  _onChangeMute = () => {
    const { mute } = this.state;

    this.setState({
      mute: !mute,
    });
  };
  _goLive = () => {
    const { history, loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      history.push('/live');
    }
  };
  //http://ah9szoaj9w.ecn.cdn.infralab.net/images/review/
  render() {
    const { liveData, playing, playUrl, imgShow, wSize, hSize, mute } =
      this.state;
    const { imgUrl } = this.props;

    //console.log(wSize)
    //const bt = window.innerWidth
    return (
      <Fragment>
        {liveData ? (
          <div className="top_baner" onClick={this._goLive}>
            <div className="live_img">
              <img src={imgUrl + '/img/live.png'} />
            </div>

            <div className="text_group">
              <div style={{ paddingBottom: 10 }}>
                {liveData[0].imageLO ? (
                  <img
                    src={liveData[0].imageLO}
                    style={{ width: '30%', height: '30%' }}
                  />
                ) : null}
              </div>
              <div
                className="top_baner_name"
                style={{ fontSize: wSize * 0.025, paddingTop: 20 }}
              >
                {liveData[0].title}
              </div>
              <div className="center_group">
                <h1>
                  {/*<img src="/img/cheosbang.png"/>*/}
                  {liveData[0].subTitle}
                </h1>
                <p>
                  {liveData[0].contentEpisode === '' ||
                  liveData[0].contentEpisode === null ||
                  liveData[0].contentEpisode === undefined
                    ? null
                    : liveData[0].contentEpisode}
                  {/*<a style={{cursor: 'pointer'}} onClick={()=>this._goItem(liveData[0].contentSerial)}>작품상세보기</a>*/}
                </p>

                <div className="line_bg">
                  <div
                    style={{
                      backgroundColor: '#fff',
                      height: '100%',
                      poisition: 'relative',
                      width:
                        liveData[0].ratio > 100
                          ? '100%'
                          : liveData[0].ratio + '%',
                    }}
                  ></div>
                  <span>{liveData[0].outputStart.substr(0, 5)}</span>
                  <em>{liveData[0].outputEnd.substr(0, 5)}</em>
                  {/*<div className="s_img"><img src="/img/mueum.png"/></div>*/}
                </div>
              </div>
              {/*<div className="p_btn" style={{top: wSize*0.06}}><span><img src="img/play1.png"/> 지금 시청하기</span></div>*/}
            </div>
            <div className="bg_img2" onClick={this._goLive}></div>
            {imgShow ? (
              <div className="bg_img">
                <img
                  src={
                    liveData[0].thumbImg === '' ||
                    liveData[0].thumbImg === null ||
                    liveData[0].thumbImg === undefined
                      ? null
                      : liveData[0].thumbImg
                  }
                  style={{ width: wSize, height: hSize }}
                />
              </div>
            ) : (
              <ReactPlayer
                //url={'https://jjmp4.ofscdn.com' + liveData[0].opening}
                className="bg_img"
                playing={playing}
                url={playUrl}
                volume={0.5}
                muted={mute}
                onReady={this._onReady}
                onEnded={this._onEnded}
                style={{ width: wSize, height: hSize }}
                width={wSize}
                height={hSize}
              />
            )}
          </div>
        ) : null}
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TopLiveBanner));
